import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, ButtonGroup, ClickAwayListener, MenuItem, MenuList, Paper, Popover } from "@mui/material";
import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import ButtonWithAPICallComponent from "./ButtonWithAPICall.component";
import { DeleteDialog } from "./dialog.component";

export const statusOptions = [
  { label: "DEACTIVATED", action: 0, label1: "DEACTIVATE" },
  { label: "ACTIVATED", action: 1, label1: "ACTIVATE" },
  { label: "DELETED", action: 4, label1: "DELETE" },
];
export const ticketStatusOptions = ["PUBLISHED", "APPROVED", "REPLACED", "DELETED", "FAIL"];
const SelectStatusButton = ({ ...buttonProps }) => {
  const [t] = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState({ ...statusOptions[0] });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const handleClose = (event) => {
    if (ref.current?.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  return (
    <React.Fragment>
      <ButtonGroup disabled={buttonProps.disabled} ref={ref} color="info" style={{ height: 30 }}>
        <ButtonWithAPICallComponent
          size="small"
          dialogNode={
            selectedStatus.action === 4 &&
            function (params) {
              // neu selected status === deleted thi co thong bao xac nhan xoa
              return <DeleteDialog {...params} />;
            }
          }
          {...buttonProps}
          api={() => buttonProps.api(selectedStatus)}
          response={(res) => buttonProps.response(res, selectedStatus)}
          // sx={{}}
        >
          {t(selectedStatus.label1)}
        </ButtonWithAPICallComponent>
        <Button onClick={(prev) => setOpen(true)}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popover
        open={Boolean(open)}
        anchorEl={ref.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList>
              {statusOptions.map((option, index) => (
                <MenuItem
                  key={option.label}
                  selected={option === selectedStatus}
                  onClick={(event) => {
                    setSelectedStatus(option);
                    setOpen(false);
                  }}
                >
                  {t(option.label1)}
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popover>
    </React.Fragment>
  );
};
export default SelectStatusButton;
